module.exports = __webpack_public_path__ + "static/img/union-bank-icon.7eca2312.png";